var map = {
	"./announcement/reducer.js": 1012,
	"./app/reducer.js": 1013,
	"./auth/reducer.js": 1745,
	"./battle/reducer.js": 1014,
	"./business/reducer.js": 1015,
	"./effect/reducer.js": 1016,
	"./entities/reducer.js": 1017,
	"./hedgieHouse/reducer.js": 1018,
	"./hedgies/reducer.js": 1019,
	"./item/reducer.js": 1020,
	"./journey/reducer.js": 1021,
	"./leaderboard/reducer.js": 1022,
	"./level/reducer.js": 1023,
	"./notification/reducer.js": 1024,
	"./onboarding/reducer.js": 1025,
	"./resource/reducer.js": 1026,
	"./user/reducer.js": 1027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1011;